import type { NavItem } from './nav-types'

// Flattened navigation config - all top-level apps in a single array
export const flatNavigationConfig: NavItem[] = [
  // ATC — Commander Bridge (MO-COMMANDER-BRIDGE v9 §S-IA: 4 IA groups as outer tabs).
  {
    id: 'atc',
    labelKey: 'nav.atc',
    href: '/atc/bridge',
    icon: 'RadioTower',
    permission: 'atc',
    group: 'operations',
    hasTabs: true,
    tabItems: [
      { id: 'atc-operations', labelKey: 'atc.bridge.groups.operations', href: '/atc/bridge/operations/manifest', pathPrefix: '/atc/bridge/operations', icon: 'ClipboardList', tabGroup: 'atc', tabOrder: 1 },
      { id: 'atc-repos', labelKey: 'atc.bridge.groups.repos', href: '/atc/bridge/repos/prs', pathPrefix: '/atc/bridge/repos', icon: 'GitPullRequest', tabGroup: 'atc', tabOrder: 2 },
      // BUG-FE-BRIDGE-QUICKWINS-2026-06-28: the standalone agents/registry route
      // was removed in the heartbeat+registry teardown — chat is the only live
      // Agents sub-route. The group tab must default to it, never the dead
      // /atc/bridge/agents/registry path (rendered BridgeNotFound → 404).
      { id: 'atc-agents', labelKey: 'atc.bridge.groups.agents', href: '/atc/bridge/agents/chat', pathPrefix: '/atc/bridge/agents', icon: 'Users', tabGroup: 'atc', tabOrder: 3 },
      { id: 'atc-wiki', labelKey: 'atc.bridge.groups.wiki', href: '/atc/bridge/wiki', pathPrefix: '/atc/bridge/wiki', icon: 'BookOpen', tabGroup: 'atc', tabOrder: 4 },
    ],
  },
  // Warehouse — real Wackler reconciliation + payments
  {
    id: 'warehouse',
    labelKey: 'nav.warehouse',
    href: '/warehouse/payments',
    icon: 'Truck',
    permission: 'warehouse',
    group: 'supply-chain',
  },
  // Learning - has tabs
  {
    id: 'learning',
    labelKey: 'nav.learning',
    href: '/learning/curriculum',
    icon: 'GraduationCap',
    permission: 'learning',
    group: 'tools',
    hasTabs: true,
    tabItems: [
      { id: 'learning-curriculum', labelKey: 'nav.curriculumPlanning', href: '/learning/curriculum', icon: 'GraduationCap', tabGroup: 'learning', tabOrder: 1 },
      { id: 'learning-dashboard', labelKey: 'nav.learnerDashboard', href: '/learning/dashboard', icon: 'BookOpen', tabGroup: 'learning', tabOrder: 2 },
      { id: 'learning-dashboard-accessible', labelKey: 'nav.accessibleLearnerDashboard', href: '/learning/dashboard/accessible', icon: 'Accessibility', tabGroup: 'learning', tabOrder: 3 },
    ]
  },
  // Settings - has tabs
  {
    id: 'settings',
    labelKey: 'nav.settings',
    href: '/settings',
    icon: 'Settings',
    permission: 'settings',
    group: 'tools',
    hasTabs: true,
    tabItems: [
      { id: 'settings-main', labelKey: 'nav.general', href: '/settings', icon: 'Settings', tabGroup: 'settings', tabOrder: 1 },
      { id: 'settings-company', labelKey: 'nav.company', href: '/settings/company', icon: 'Building', tabGroup: 'settings', tabOrder: 2 },
      { id: 'settings-users', labelKey: 'nav.usersRoles', href: '/settings/users', icon: 'UserCog', tabGroup: 'settings', tabOrder: 3 },
    ]
  },
  // SCOUT - has tabs
  {
    id: 'scout',
    labelKey: 'nav.scout',
    href: '/scout',
    icon: 'Search',
    permission: 'scout',
    group: 'sales',
    hasTabs: true,
    tabItems: [
      { id: 'scout-weekly', labelKey: 'nav.scout.wochenplanung', href: '/scout/wochenplanung', icon: 'Calendar', tabGroup: 'scout', tabOrder: 1 },
      { id: 'scout-daily', labelKey: 'nav.scout.tagesplanung', href: '/scout/tagesplanung', icon: 'Clock', tabGroup: 'scout', tabOrder: 2 },
      { id: 'scout-prequal', labelKey: 'nav.scout.prequal', href: '/scout/prequal', icon: 'Phone', tabGroup: 'scout', tabOrder: 3 },
      { id: 'scout-callback-queue', labelKey: 'nav.scout.wiedervorlagen', href: '/scout/callback-queue', icon: 'PhoneCall', tabGroup: 'scout', tabOrder: 4 },
      { id: 'scout-praeferenzen', labelKey: 'nav.scout.praeferenzen', href: '/scout/praeferenzen', icon: 'Settings', tabGroup: 'scout', tabOrder: 5, hideForPermission: 'scout-admin' },
      { id: 'scout-mission-control', labelKey: 'nav.scout.missionControl', href: '/scout/mission-control', icon: 'Target', tabGroup: 'scout', tabOrder: 6, roles: ['Admin', 'Manager'] },
      { id: 'scout-company-search', labelKey: 'nav.scout.unternehmenssuche', href: '/scout/unternehmenssuche', icon: 'Search', tabGroup: 'scout', tabOrder: 7, permission: 'scout-admin' },
      { id: 'scout-scorecard', labelKey: 'nav.scout.scorecard', href: '/scout/scorecard', icon: 'BarChart3', tabGroup: 'scout', tabOrder: 8, permission: 'scout-admin' },
    ]
  },
  // Style Guide
  {
    id: 'style-guide',
    labelKey: 'nav.styleGuide',
    href: '/style-guide',
    icon: 'Palette'
  }
]
